import React, { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRouter } from "next/router";
import { cn } from "@/lib/utils";
import { useDarkTheme } from "@/contexts/DarkTheme";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  ChartTooltip,
  ChartTooltipContent,
  ChartContainer,
} from "@/components/ui/chart";
import {
  formatDate,
  minFixedDecimal,
  DP22,
  Pagination,
} from "@/helpers/helperFunctions";

import { Range } from "react-range";
import { BadgeAlert, BadgeCheck } from "lucide-react";
import Image from "next/image";
import { PolarAngleAxis, PolarGrid, Radar, RadarChart } from "recharts";
import Loader from "../Loader";
import { useTranslation } from "react-i18next";
import { usePostMarketPlaceFilterAuthors } from "@/api/marketPlaceApi";
import { Label } from "../ui/label";
import { Input } from "../ui/input";

let circleStyles = {
  height: "13px",
  width: "13px",
  borderRadius: "50%",
  border: "2px solid black",
  backgroundColor: "#fff",
  // backgroundColor: isDragged ? "#0a84ff" : "#999",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
let lineStyling = {
  height: "5px",
  width: "96%",
  margin: "0 auto",
  borderRadius: "3px",
};
export default function AuthorsFilters({}: any) {
  const [filtersAuthors, setFiltersAuthors]: any = useState({
    sort_order: "win_p_desc",
    total_strategies: "",
    copiers: "",
    trading_profile: "",
    win_p: "",
  });
  const { darkTheme } = useDarkTheme();
  let [pageAuthors, setPageAuthors] = useState(1);
  let [pagesAuthors, setPagesAuthors] = useState(1);
  let [totalDataLengthAuthors, setTotalDataLengthAuthors] = useState(0);
  let [dataAuthors, setDataAuthors] = useState([]);
  const [winningPercentage, setWinningPercentage] = useState<number>(0); // Initial range values
  const [totalStrategies, setTotalStrategies] = useState<number>(0); // Initial range values
  const [copiersCountSlider, setCopiersCountSlider] = useState<number>(0); // Initial range values
  const [dataSize, setDatasize] = useState(20);
  const [isAnyFilterFilled, setIsAnyFilterFilled] = useState(false);
  const { t } = useTranslation("marketplace");
  const [authorFormData, setAuthorFormData] = useState<FormData | null>(null);
  const [searchInputValueByName, setSearchInputValueByName] = useState("");
  const {
    data: filterAuthorData,
    isLoading: loadingAuthors,
    isSuccess: isSuccessAuthor,
    refetch: refetchAuthorData,
  } = usePostMarketPlaceFilterAuthors(
    authorFormData,
    String(pageAuthors),
    String(dataSize)
  );

  useEffect(() => {
    const newFormData = new FormData();
    Object.keys(filtersAuthors).map((each) => {
      newFormData.append(each, filtersAuthors[each]);
    });
    setAuthorFormData(newFormData);
  }, [filtersAuthors]);

  useEffect(() => {
    const checkForFilters = Object.entries(filtersAuthors)
      .filter(([key]) => key !== "sort_order") // Exclude 'sort_order'
      .some(([, value]) => value !== ""); // Check if any remaining value is filled

    setIsAnyFilterFilled(checkForFilters);
  }, [filtersAuthors]);

  useEffect(() => {
    refetchAuthorData();
  }, [authorFormData]);

  useEffect(() => {
    if (isSuccessAuthor && filterAuthorData) {
      setDataAuthors(filterAuthorData.data.items);
      setTotalDataLengthAuthors(filterAuthorData.data.total);
      setPagesAuthors(filterAuthorData.data.pages);
    }
  }, [filterAuthorData, isSuccessAuthor]);

  const handleChange = (name: string, value: string) => {
    setFiltersAuthors((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };
  let [userInfo, setUserInfo]: any = useState({});
  useEffect(() => {
    if (typeof window !== undefined) {
      const u = JSON.parse(localStorage.getItem("user-info")!);
      setUserInfo(u);
    }
  }, []);
  const STEP = 1;
  const MIN = 0;
  const MAX = 10;
  const router = useRouter();
  const getNameInitials = (name: any) => {
    const initials = name
      .split(" ")
      .slice(0, 2)
      .map((word: any) => word.charAt(0))
      .join("");
    return initials.toUpperCase();
  };
  let clearFilters = () => {
    setWinningPercentage(0);
    setCopiersCountSlider(0);
    setFiltersAuthors({
      sort_order: "",
      total_strategies: "",
      copiers: "",
      trading_profile: "",
      win_p: "",
      author_name: "",
    });
  };

  useEffect(() => {
    if (searchInputValueByName) {
      handleChange("author_name", searchInputValueByName);
    } else {
      handleChange("author_name", "");
    }
  }, [searchInputValueByName]);

  return (
    // <div className="w-full h-full flex flex-col lg:flex-row justify-between lg:pb-10">
    <>
      <div className="w-[100%]   sticky sm:w-[27%] h-full">
        <Card className="w-[100%] h-auto  ">
          <CardHeader className="text-xl font-bold flex flex-row justify-between items-center">
            <div className="w-fit">{t("Filters")}</div>

            {isAnyFilterFilled && (
              <Image
                width={26}
                height={26}
                src="/images/marketplace/cross.png"
                alt="filter image"
                className={`mr-2 cursor-pointer ${
                  darkTheme ? "" : "marketplace-filter-icon-dark"
                }`}
                onClick={clearFilters}
              />
            )}
          </CardHeader>
          <CardContent>
            <Label>Search by name</Label>
            <Input
              className="mt-2"
              value={searchInputValueByName}
              onChange={(e) => setSearchInputValueByName(e.target.value)}
            ></Input>
          </CardContent>

          <CardContent>
            <div className="mb-[8px]">Trading Profile</div>
            <Select
              value={filtersAuthors.trading_profile}
              onValueChange={(value) => handleChange("trading_profile", value)}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Select" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectItem value={"Volatility"}>Volatility</SelectItem>
                  <SelectItem value={"Overlap"}>Overlap</SelectItem>
                  <SelectItem value={"Momentum"}>Momentum</SelectItem>
                  <SelectItem value={"Volume"}>Volume</SelectItem>
                  <SelectItem value={"Trend"}>Trend</SelectItem>
                  <SelectItem value={"Statistics"}>Statistics</SelectItem>
                  <SelectItem value={"Cycles"}>Cycles</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>
          </CardContent>

          <CardContent>
            <div className="mb-[8px]">
              {t("Win Percentage")} ({winningPercentage}%)
            </div>

            <Range
              step={STEP}
              min={MIN}
              max={100}
              values={[winningPercentage]}
              onChange={(values) => {
                setWinningPercentage(values[0]);
                handleChange("win_p", String(values[0]));
              }}
              renderTrack={({ props, children }) => {
                const percent = ((winningPercentage - MIN) / (100 - MIN)) * 100;
                return (
                  <div
                    {...props}
                    style={{
                      ...props.style,
                      ...lineStyling,
                      background: `linear-gradient(to right, hsl(var(--primary)) 0%, hsl(var(--primary)) ${percent}%, hsl(var(--muted)) ${percent}%, hsl(var(--muted)) 100%)`,
                    }}
                  >
                    {children}
                  </div>
                );
              }}
              renderThumb={({ props, isDragged }) => {
                const { key, ...restProps } = props;
                return (
                  <div
                    key={key}
                    {...restProps}
                    style={{
                      ...props.style,
                      ...circleStyles,
                    }}
                  />
                );
              }}
            />
          </CardContent>
          <CardContent>
            <div className="mb-[8px]">
              {t("Copiers")} ({copiersCountSlider})
            </div>

            <Range
              step={STEP}
              min={MIN}
              max={MAX}
              values={[copiersCountSlider]}
              onChange={(values) => {
                setCopiersCountSlider(values[0]);
                handleChange("copiers", String(values[0]));
              }}
              renderTrack={({ props, children }) => {
                const percent =
                  ((copiersCountSlider - MIN) / (MAX - MIN)) * 100;

                return (
                  <div
                    {...props}
                    style={{
                      ...props.style,
                      ...lineStyling,
                      //   background: `linear-gradient(to right, #000 0%, #000 ${percent}%, #ccc ${percent}%, #ccc 100%)`,
                      background: `linear-gradient(to right, hsl(var(--primary)) 0%, hsl(var(--primary)) ${percent}%, hsl(var(--muted)) ${percent}%, hsl(var(--muted)) 100%)`,
                    }}
                  >
                    {children}
                  </div>
                );
              }}
              renderThumb={({ props, isDragged }) => {
                const { key, ...restProps } = props;

                return (
                  <div
                    key={key}
                    {...restProps}
                    style={{
                      ...props.style,
                      ...circleStyles,
                    }}
                  />
                );
              }}
            />
          </CardContent>

          <CardContent>
            <div className="mb-[8px]">Total Strategies ({totalStrategies})</div>

            <Range
              step={STEP}
              min={MIN}
              max={100}
              values={[totalStrategies]}
              onChange={(values) => {
                setTotalStrategies(values[0]);
                handleChange("total_strategies", String(values[0]));
              }}
              renderTrack={({ props, children }) => {
                const percent = ((totalStrategies - MIN) / (100 - MIN)) * 100;
                return (
                  <div
                    {...props}
                    style={{
                      ...props.style,
                      ...lineStyling,
                      background: `linear-gradient(to right, hsl(var(--primary)) 0%, hsl(var(--primary)) ${percent}%, hsl(var(--muted)) ${percent}%, hsl(var(--muted)) 100%)`,
                    }}
                  >
                    {children}
                  </div>
                );
              }}
              renderThumb={({ props, isDragged }) => {
                const { key, ...restProps } = props;
                return (
                  <div
                    key={key}
                    {...restProps}
                    style={{
                      ...props.style,
                      ...circleStyles,
                    }}
                  />
                );
              }}
            />
          </CardContent>
        </Card>
      </div>
      {/* <div></div> */}
      <Card className="w-full relative  mt-5 sm:mt-0 sm:w-[71%] h-[70vh] overflow-auto">
        {/* <div className="max-h-[45vh] lg:max-h-[70vh] overflow-scroll"> */}
        <CardHeader className="flex  !p-3 px-6 justify-between flex-row items-center w-full">
          <CardTitle className="text-xl flex gap-2 items-center text-nowrap">
            {t("Top Traders")}
          </CardTitle>
          <div className="sortFilterMarketplace">
            <Select
              value={filtersAuthors.sort_order}
              onValueChange={(value) => {
                if (value == "none") {
                  value = "";
                }
                handleChange("sort_order", value);
              }}
            >
              <SelectTrigger className="w-[50px] outline-none cursor-pointer border-none bg-transparent text-lg ">
                <Image
                  width={22}
                  height={22}
                  src="/images/marketplace/filter.png"
                  alt="filter image"
                  className={`mr-2 cursor-pointer ${
                    darkTheme ? "" : "marketplace-filter-icon-dark"
                  }`}
                />
              </SelectTrigger>

              <SelectContent>
                <SelectGroup>
                  {/* {filtersAuthors.sort_order && (
                      <SelectItem value="none" className="cursor-pointer">
                        Default
                      </SelectItem>
                    )} */}

                  <SelectItem value={"win_p_desc"}>
                    Highest Win Percentage
                  </SelectItem>
                  <SelectItem value={"copiers_desc"}>
                    Highest Copiers Count
                  </SelectItem>
                  <SelectItem value={"total_strategies_desc"}>
                    Highest Strategies Created
                  </SelectItem>
                  <SelectItem value={"total_trades_desc"}>
                    Highest Trades Triggered
                  </SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
        </CardHeader>
        {loadingAuthors || dataAuthors.length == 0 ? (
          !loadingAuthors ? (
            <div className="w-full flex items-center justify-center h-[200px]">
              No data found
            </div>
          ) : (
            <div className="w-full flex items-center justify-center h-[200px]">
              <Loader />
            </div>
          )
        ) : (
          <CardContent className={`p-3 pt-0 w-full`}>
            <div className="flex flex-wrap w-full justify-between">
              {dataAuthors.map((each: any, i: number) => {
                let firstName = each?.user?.first_name?.split(" ")[0];
                let lastName = each?.user?.last_name?.split(" ")[0];
                let fullName = firstName + " " + lastName;

                let badgeValue = JSON.parse(
                  each?.meta_data?.user_meta?.badge
                )?.last_badge;

                let allCategories = each?.meta_data?.trading_profile_categories;
                //   let allCategories = [
                //     "Statistics",
                //     "Overlap",
                //     "Volatility",
                //     "Volume",
                //     "Momentum",
                //     "Trend",
                //     "Cycles",
                //   ];
                let profileData = each?.meta_data?.trading_profile_graph;
                let graphData: any = [];
                profileData &&
                  Object.keys(profileData).forEach((key) => {
                    graphData.push({
                      name: key,
                      value: profileData?.[key],
                    });
                  });
                let missingData = allCategories
                  .filter(
                    (item: any) =>
                      !graphData.some((data: any) => data.name === item)
                  )
                  .map((item: any) => ({ name: item, value: 0 }));
                let newData = [...graphData, ...missingData];
                return (
                  <Card
                    key={each.user.email}
                    className="p-0 w-full  sm:w-[49%] mb-5 p-4 "
                  >
                    {userInfo?.user_id ? (
                      <div
                        className="flex items-center cursor-pointer text-sm max-w-fit"
                        onClick={() =>
                          router.push(
                            `/profile/${each.user.unique_key}?locale=${
                              router.query.locale || "en"
                            }`
                          )
                        }
                      >
                        <div
                          className={cn(
                            "flex h-full w-full items-center justify-center rounded-full bg-muted w-[28px] h-[28px] mr-2 text-xs "
                          )}
                        >
                          {getNameInitials(fullName)}
                        </div>
                        {fullName}

                        {badgeValue == "rock" ? (
                          <BadgeAlert className="text-[#9B0505] w-[16px] h-[16px] ml-2" />
                        ) : badgeValue == "bronze" ? (
                          <BadgeCheck className="text-[#cd7f32] w-[16px] h-[16px] ml-2" />
                        ) : badgeValue == "silver" ? (
                          <BadgeCheck className="text-[#19438A] w-[16px] h-[16px] ml-2" />
                        ) : badgeValue == "gold" ? (
                          <BadgeCheck className="text-[#FFD700] w-[16px] h-[16px] ml-2" />
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      <HoverCard>
                        <HoverCardTrigger asChild>
                          <div className="flex items-center cursor-pointer text-sm max-w-fit">
                            <div
                              className={cn(
                                "flex h-full w-full items-center justify-center rounded-full bg-muted w-[28px] h-[28px] mr-2 text-xs "
                              )}
                            >
                              {getNameInitials(fullName)}
                            </div>
                            {fullName}

                            {badgeValue == "rock" ? (
                              <BadgeAlert className="text-[#9B0505] w-[16px] h-[16px] ml-2" />
                            ) : badgeValue == "bronze" ? (
                              <BadgeCheck className="text-[#cd7f32] w-[16px] h-[16px] ml-2" />
                            ) : badgeValue == "silver" ? (
                              <BadgeCheck className="text-[#19438A] w-[16px] h-[16px] ml-2" />
                            ) : badgeValue == "gold" ? (
                              <BadgeCheck className="text-[#FFD700] w-[16px] h-[16px] ml-2" />
                            ) : (
                              ""
                            )}
                            {/* <ExternalLinkIcon className="text-muted-foreground ml-2 w-[16px] h-[16px]" /> */}
                          </div>
                        </HoverCardTrigger>
                        <HoverCardContent className="w-80">
                          <div className="flex justify-between space-x-4">
                            <div className="space-y-1">
                              <p className="text-sm">
                                You need to create an account with us to access
                                this feature
                              </p>
                              <div className="mt-5 w-[100%] relative h-[42px]">
                                <div className="absolute right-0 top-2">
                                  <a href={`/create-new-account`}>
                                    <Button className="flex items-center h-[34px]">
                                      Sign Up
                                    </Button>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </HoverCardContent>
                      </HoverCard>
                    )}

                    <div className="text-[10px] text-muted-foreground mt-[4px]">
                      Member since{" "}
                      {formatDate(each?.user?.created_at, "DD-MMM-YY")}
                    </div>
                    <div className="sm:flex sm:justify-between mt-2">
                      <div
                        className="w-full sm:w-[55%] min-h-[135px] flex items-center justify-center "
                        id="marketplace-chart"
                      >
                        <ChartContainer
                          config={{
                            value: {
                              color: "rgba(72,109,246,1)",
                            },
                          }}
                          className="w-[100%] h-full"
                        >
                          <RadarChart
                            data={newData}
                            margin={{
                              top: 12,
                              right: 12,
                              left: 12,
                              bottom: 12,
                            }}
                          >
                            <ChartTooltip
                              cursor={false}
                              content={
                                <ChartTooltipContent
                                  formatter={(value) =>
                                    minFixedDecimal(value as number, DP22) + "%"
                                  }
                                />
                              }
                            />
                            <PolarAngleAxis dataKey="name" />
                            <PolarGrid />
                            <Radar
                              dataKey="value"
                              fill="var(--color-value)"
                              dot
                              fillOpacity={0.6}
                            />
                          </RadarChart>
                        </ChartContainer>
                      </div>
                      <div className="w-full sm:w-[45%] text-nowrap flex flex-col justify-between">
                        <div className="flex items-end justify-between ">
                          <div className="w-[55%]">
                            <div className="text-3xl font-bold">
                              {each?.meta_data?.win_p >= 75 ? (
                                <div className="text-[--marketplace-green] items-end">
                                  {each?.meta_data?.win_p?.toFixed(0)}
                                  <span className="text-base">%</span>
                                </div>
                              ) : each?.meta_data?.win_p >= 50 ? (
                                <div className="text-[--marketplace-blue] items-end">
                                  {each?.meta_data?.win_p?.toFixed(0)}
                                  <span className="text-base">%</span>
                                </div>
                              ) : each?.meta_data?.win_p >= 0 ? (
                                <div className="text-[--marketplace-red] items-end">
                                  {each?.meta_data?.win_p?.toFixed(0)}
                                  <span className="text-base">%</span>
                                </div>
                              ) : (
                                "NA"
                              )}
                            </div>

                            <div className="text-[10px] text-[var(--marketplace-grey)] font-semibold">
                              Average Win
                            </div>
                          </div>

                          <div className="w-[45%] ">
                            <div className="text-xl font-medium">
                              {each?.meta_data?.copiers_count}
                            </div>
                            <div className="text-[10px] text-[var(--marketplace-grey)] font-semibold">
                              Copiers Count
                            </div>
                          </div>
                        </div>

                        <div className="flex items-start mt-2 pb-2">
                          <div className="w-[55%]">
                            <div className="text-[10px] text-[var(--marketplace-grey)] font-semibold">
                              Total Strategies
                            </div>
                            <div className="text-xl font-medium">
                              {each?.meta_data?.total_strategies}
                            </div>
                          </div>
                          <div className="w-[45%]">
                            <div className="text-[10px] text-[var(--marketplace-grey)] font-semibold">
                              Total Trades
                            </div>
                            <div className="text-xl font-medium">
                              {each?.meta_data?.total_trades}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card>
                );
              })}
            </div>
            <div className="mt-3 mb-10 sm:mb-0">
              <Pagination
                totalCount={totalDataLengthAuthors}
                currentPage={pageAuthors}
                changePage={setPageAuthors}
                limit={dataSize}
              />
            </div>
          </CardContent>
        )}
        {/* </div> */}
      </Card>
    </>
  );
}
